import * as React from "react";
import { useNavigate } from "react-router-dom";
import { CREATE_GAME_PATH } from "../../utils/routesPaths";
import {
  CardsImage,
  HomeHeading,
  HomepageWrapper,
  HomeParagraph,
  StartGameButton,
  WelcomeTextWrapper,
} from "../Home/Home.components";
import PageWrapper from "../shared/PageWrapper";

const Home: React.FunctionComponent = () => {
  const navigate = useNavigate();

  const onClickRedirect = React.useCallback(() => {
    navigate(CREATE_GAME_PATH);
  }, [history]);

  return (
    <PageWrapper>
      <HomepageWrapper>
        <WelcomeTextWrapper>
          <HomeHeading>Scrum Poker as simple as ever</HomeHeading>
          <HomeParagraph>
            Your future favourite poker pointing app
          </HomeParagraph>
          <StartGameButton
            themeColor="buttonPrimary"
            disabled={false}
            onClick={onClickRedirect}>
            Start new game
          </StartGameButton>
        </WelcomeTextWrapper>

        <CardsImage />
      </HomepageWrapper>
    </PageWrapper>
  );
};

export default Home;
